import { Component, OnInit, ViewChild, EventEmitter, ChangeDetectionStrategy, Input, AfterViewInit, OnChanges, SimpleChanges, forwardRef, ViewEncapsulation, Output } from "@angular/core";
import { Validators, ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ControlDisplayMode, DataFor, ReminderDisplayMode, ReminderTypes } from '../../../Shared/enum';
import { Observable, of } from 'rxjs';
import { filter, startWith, map, switchMap } from 'rxjs/operators';
import { IData, IQuickSearchable } from '../../../Shared/common';
import { Global } from '../../../Shared/global';
import { CommonDataService } from '../../../Services/commonDataService';
import { User } from "../../../Models/FitnessBox/User";
import { DateAdapter } from '@angular/material/core';
import { Reminder } from "../../../Models/Common/Reminder";
import { ReminderType } from "../../../Models/Common/ReminderType";
import { ReminderResponseType } from "../../../Models/Common/ReminderResponseType";

@Component({
  templateUrl: './reminder-control.html',
  selector: 'reminder-control',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReminderControlComponent),
      multi: true
    }
  ]
})
export class ReminderControlComponent implements OnInit, AfterViewInit, OnChanges, ControlValueAccessor {
  field: FieldConfig;
  group: FormGroup;

  @ViewChild('modal', /* TODO: add static flag */ {}) modal: NgxSmartModalService;
  @Input() filter = "";
  @ViewChild('dataInput', /* TODO: add static flag */ {}) dataInput: Input;

  //Attributes
  @Input() DisplayMode: ReminderDisplayMode = null;
  @Input() dataFor: DataFor = null;
  @Input() EnumDataFor: any = DataFor;
  @Input() required: boolean = false;
  @Input() formControlName: any;
  @Input() selectedData: Reminder = new Reminder();
  @Input() placeholderText: string = "";
  @Output() reminderSaved = new EventEmitter();
  @Input() GetDataAsEntity: boolean = true;
  @Input() dynamicData: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() EventTypeSelectionEnabled: boolean = false;
  @Input() modalTitle: string = 'Configure Reminder';
  @Input() ReminderTypes: ReminderTypes = ReminderTypes.General;
  @Input() RelatedModuleName: string = "";
  @Input() RelatedModuleId: number = 0;
  @Input() CreatedBy: User = null;
  @Input() AllDay: boolean = false;
  @Input() ForceEnable: boolean = false;
  @Input() CompactView: boolean = false;
  @Input() SelectedSubType: ReminderType = null;
  @Input() SelectedResponseType: ReminderResponseType = null;
  @Input() SubTypeList: ReminderType[] = [];
  @Input() ResponseTypeList: ReminderResponseType[] = [];
  @Input() DisableSubType: boolean = false;
  @Input() DisableResponseType: boolean = false;
  @Input() SubTypeLabel: string = "";
  @Input() ResponseTypeLabel: string = "";

  //
  $allData: Observable<IQuickSearchable[]>;
  $filteredData: Observable<IQuickSearchable[]>;
  filteredOptions: Observable<IQuickSearchable[]>;
  dataForm: FormGroup;
  myControl: FormControl = new FormControl();

  constructor(private fb: FormBuilder, private _service: CommonDataService, public ngxSmartModalService: NgxSmartModalService) {

  }

  ngOnInit() {
    this.dataForm = this.fb.group({
      data: [null, (this.required ? Validators.required : null)]
    });
    //this.LoadData();
    this.LoadDefaults();
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  showReminderbox() {
    this.modal.open('modal', false);
  }

  LoadData() {
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + this.getApiName(this.dataFor) + Global.getSearchParameters(20, !this.dynamicData, this.filter))
      .then((x) => {
        this.$allData = of(x.ListItems);
        this.$filteredData = this.data.valueChanges
          .pipe(
            startWith(''),
            switchMap(value => this.filterDataList(value))
          );

      })
      .catch(error => Global.Log(error));
  }

  LoadDefaults() {
    if (this.DisplayMode == ReminderDisplayMode.CommentsWithTypes) {
      if (this.SubTypeList == null || this.SubTypeList?.length <= 0) {
        this.populateReminderSubTypes();
      }
      if (this.ResponseTypeList == null || this.ResponseTypeList?.length <= 0) {
        this.populateReminderResponseTypes();
      }
    }
  }

  valuechange(evt) {
    if (this.dynamicData) {
      this.filter = evt.target.value;
      this.LoadData();
    }

  }

  private filterDataList(value: string | IQuickSearchable) {
    let filterValue = '';
    if (value) {
      filterValue = typeof value === 'string' ? value.toLowerCase() : (value.Name != undefined ? value.Name.toLowerCase() : '');
      return this.$allData.pipe(
        map(dt => dt.filter(itm => itm.Name?.toLowerCase().includes(filterValue)))
      );
    } else {
      return this.$allData;
    }
  }

  private populateReminderSubTypes() {
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + this.getEndpointUrl("remindersubtype",this.selectedData.ReminderType))
      .then((x) => {
        if (x.ListItems) {
          this.SubTypeList = <ReminderType[]>x.ListItems;
        }
      })
      .catch(error => { Global.Log(error); this.SubTypeList = []; });
  }

  private populateReminderResponseTypes() {
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + this.getEndpointUrl("reminderresponsetype",0))
      .then((x) => {
        if (x.ListItems) {
          this.ResponseTypeList = <ReminderResponseType[]>x.ListItems;
        }
      })
      .catch(error => { Global.Log(error); this.ResponseTypeList = []; });
  }

  get data() {
    return this.dataForm.get('data');
  }

  itemSelected($event) {
    if (this.data != undefined && this.data?.value != undefined && this.data?.value != null) {
      if (this.GetDataAsEntity) {
        this.reminderSaved.emit(this.data.value);
      }
      else {
        this.reminderSaved.emit(this.data);
      }

    }
    else {
      //this.data.setValue($event.option.value);
      if (this.GetDataAsEntity) {
        this.reminderSaved.emit(this.data.value);
      }
      else {
        this.reminderSaved.emit(this.data);
      }
    }
  }

  panelClosed($event) {
    if (this.data != undefined && typeof this.data.value === 'string' && this.data.value != "") {
      this.dataForm.get('data').reset();
      this.dataForm.get('data').markAsDirty();
    }

    if (this.GetDataAsEntity) {
      this.propagateChange(this.data.value);
    }
    else {
      this.propagateChange(this.data);
    }
  }

  getApiName(listType: DataFor): string {
    let apiPath: string = "";
    switch (listType) {
      case DataFor.Brand:
        apiPath = Global.BrandSearchApi;
        break;
      case DataFor.Category:
        apiPath = Global.CategorySearchApi;
        break;
      case DataFor.Country:
        apiPath = Global.CountrySearchApi;
        break;
      case DataFor.Location:
        apiPath = Global.StorageLocationSearchApi;
        break;
      case DataFor.Product:
        apiPath = Global.ProductSearchApi;
        break;
      case DataFor.Tax:
        apiPath = Global.TaxSearchApi;
        break;
      case DataFor.Customer:
        apiPath = Global.CustomerSearchApi;
        break;
      case DataFor.Distributor:
        apiPath = Global.DistributorSearchApi;
        break;
      //FitnessBox///
      case DataFor.Member:
        apiPath = Global.MemberSearchApi;
        break;
      case DataFor.MembershipPlan:
        apiPath = Global.MembershipPlanSearchApi;
        break;
      case DataFor.UserMembershipPlan:
        apiPath = Global.UserMembershipPlanSearchApi;
        break;
      case DataFor.UserMembershipPlanTemplate:
        apiPath = Global.UserMembershipPlanTemplateSearchApi;
        break;
      case DataFor.BodyPart:
        apiPath = Global.BodyPartSearchApi;
        break;
      case DataFor.MeasurementUnit:
        apiPath = Global.MeasurementUnitSearchApi;
        break;
      case DataFor.Gender:
        apiPath = Global.GenderSearchApi;
        break;
      case DataFor.User:
        apiPath = Global.UserSearchApi;
        break;
      case DataFor.Employee:
        apiPath = Global.EmployeeContractorSearch;
        break;
      case DataFor.Trainer:
        apiPath = Global.EmployeeContractorSearch;
        break;
      case DataFor.Dietician:
        apiPath = Global.EmployeeContractorSearch;
        break;
      default:
        apiPath = "";
        break;
    }

    return apiPath;
  }

  getEndpointUrl(apiname: string, id: number): string {
    let apiPath: string = "";
    switch (apiname) {
      case "remindertype":
        apiPath = Global.ReminderTypesListEndpoint;
        break;
      case "remindersubtype":
        apiPath = Global.ReminderSubTypesListEndpoint + Global.getSingleItemParameters(id);
        break;
      case "reminderresponsetype":
        apiPath = Global.ReminderResponseTypesListEndpoint;
        break;
      default:
        apiPath = "";
        break;
    }

    return apiPath;
  }

  compareObjects(o1: any, o2: any): boolean {
    return Global.compareObjects(o1, o2);
  }

  //---------------------------------Control Value Accessor Starts-------------------------------------
  //propagate changes into the custom form control
  propagateChange = (_: any) => { }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value instanceof FormControl) {
      this.selectedData = value.value ? value.value : new Reminder();
    }
    else {
      this.selectedData = value ? value : new Reminder();
    }
    //this.dataForm.get('data').setValue(this.selectedData, { emitModelToViewChange: true });
    this.dataForm.get('data').setValue(this.selectedData);
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {

  }
  //----------------------------------Control Value Accessor Ends---------------------------------------

}
